import slideToggle from '../utilities/slideToggle.js';
import { fetchProducts, fetchUpsellProducts } from '../utilities/fetchProducts.js';

// Inline cart functionality
const inlineCart = () => {
  const promoBundleProductId = '15692740690300';
  const defaultPromoCapVariantId = '56789438464380';
  const promoCapVariantIds = [defaultPromoCapVariantId, '56789438497148'];
  const cartHeaderIcon = document.getElementById('cart-icon-bubble');
  const inlineCart = document.querySelector('.inline-cart');
  const inlineCartClose = document.querySelector('.inline-cart_close');
  const inlineCartPageOverlay = document.querySelector('.inline-cart__page-overlay');

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class' && inlineCart.classList.contains('active')) {
        document.body.classList.add('body--no-scroll');

        (async () => {
          await renderCartItems();
          getCartTotal();
        })();
      } else if (mutation.attributeName === 'class') {
        document.body.classList.remove('body--no-scroll');
      }
    });
  });

  observer.observe(inlineCart, { attributes: true });

  function toggleCart() {
    inlineCart.classList.toggle('active');
    inlineCartPageOverlay.classList.toggle('active');
  }

  cartHeaderIcon.addEventListener('click', toggleCart);
  inlineCartClose.addEventListener('click', toggleCart);
  inlineCartPageOverlay.addEventListener('click', toggleCart);

  const shipping = window.cartData.baseShippingPrice || 0;
  let freeShipping = false;
  const initialLoadCartItems = document.querySelectorAll(".inline-cart-item");

  const productIds = Array.from(initialLoadCartItems).map(item => {
    const productId = item.dataset.productId;
    return productId;
  });

  fetchProducts(productIds)
    .then(products => {
      const cartItems = document.querySelectorAll(".inline-cart-item");

      const productMap = new Map();
      products.forEach((product) => {
        const numericId = product.id;
        productMap.set(numericId, product);
      });

      let subTotalPrice = 0;

      cartItems.forEach(item => {
        const productId = item.dataset.productId;
        const productData = productMap.get(productId);
        if (!productData) return;

        const quantity = Number(item.querySelector(".displayed-quantity").innerText);
        const tagEl = item.querySelector('.cart-item__tag');
        const compareAtPriceEl = item.querySelector('.cart-item__compare-at-price');
        const savingPercentageEl = item.querySelector('.cart-item__savings--percentage');
        const pricePerProduct = item.dataset.pricePerProduct;

        if (tagEl && productData.supportingTagLine) {
          tagEl.textContent = productData.supportingTagLine;
        }
        if (compareAtPriceEl && productData.compareAtPrice) {
          compareAtPriceEl.textContent = formatMoney((productData.compareAtPrice * quantity) * 100);
          item.dataset.compareAtPrice = productData.compareAtPrice;
        }

        if (savingPercentageEl && pricePerProduct && productData.compareAtPrice) {
          savingPercentageEl.innerText = `${(((productData.compareAtPrice - (pricePerProduct / 100)) / productData.compareAtPrice) * 100).toFixed(0)}%`;
        }

        subTotalPrice += item.dataset.compareAtPrice * quantity;
      });
      // Subtotal is the items only. The base shipping price used to be added in
      // here too (three $29.99 items read "$99.96") so the struck-through total
      // would include the shipping saving; that saving now shows only in the
      // strike-through and the discount rows.
      if (subTotalPrice > 0) {
        document.querySelector('.cart-subtotal__amount').innerText = formatMoney(subTotalPrice * 100);
      }
      document.querySelector('.cart-total__strike').innerText = formatMoney((subTotalPrice + shipping) * 100);
    })
    .catch(console.error);

  document.querySelector(".cart-delivery-info").addEventListener("click", function () {
    $(".cart-delivery-info__expanded").slideToggle(300);
  });


  const pointsEarnedEl = document.querySelector(".points-earned");
  if (pointsEarnedEl) {
    pointsEarnedEl.addEventListener("click", function () {
      $(this).toggleClass("active");
      $(".points-earned__info").slideToggle(300);
    });
  }

  document.querySelector('.apply-discount').addEventListener('click', async () => {
    const codeInput = document.getElementById('discount-code');
    const codeValue = codeInput.value.toLowerCase();

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codeValue })
    })
      .then(res => res.json())
      .then(res => {
        const discountCodes = res.discount_codes || [];
        const matchedCode = discountCodes.find(dc => dc.code.toLowerCase() === codeValue);

        if (!matchedCode) {
          console.warn(`Code "${submittedCode}" not found in cart response.`);
          return;
        }

        if (matchedCode.applicable) {
          const coupon = createCouponElement(codeValue);
          document.querySelector('.display-discount').appendChild(coupon);
          getCartTotal();
        } else {
          document.querySelector('.discount-code-error').textContent = `Invalid discount code - ${codeValue}`;
          slideToggle(document.querySelector(".discount-code-error"), 300);
          setTimeout(() => {
            slideToggle(document.querySelector(".discount-code-error"), 300);
          }, 5000);
        }

        codeInput.value = '';
      })
  })

  document.querySelectorAll(".inline-cart-item").forEach(item => {
    bindActions(item);
  });

  function upsellProducts() {
    const upsellProductToDisplay = [
      "15399219855740", // D
      "15399386317180", // E
      "15399391756668", // HSN
      "15399397753212"  // F
    ];

    // Map of upsell product IDs to their exclusion product IDs (products that shouldn't be shown if the exclusion product is in the cart)
    // e.g - There are 2 Vitamin D products, 
    // Main Vitamin D product will be 6122953244852
    // Promo Vitamin D product will be 15399219855740
    // We don't want to show the promo product if Vitamin D is already in the cart.
    const exclusionMap = {
      "15399219855740": "6122953244852",
      "15399386317180": "8195316908278",
      "15399391756668": "4695704272981",
      "15399397753212": "8010741809398"
    };

    // Get product IDs from current cart DOM items
    const cartItems = document.querySelectorAll('li.inline-cart-item');
    const cartProductIds = Array.from(cartItems).map(item => item.dataset.productId);

    // Filter upsells to exclude those already in cart or linked to an exclusion
    const filteredUpsells = upsellProductToDisplay.filter(id => {
      const exclusionId = exclusionMap[id];
      return !cartProductIds.includes(id) && !(exclusionId && cartProductIds.includes(exclusionId));
    });


    fetchUpsellProducts(filteredUpsells)
      .then(products => {
        const productMap = new Map();
        products.forEach((product) => {
          const variantId = product.variantId;
          const price = product.price;
          const compareAtPrice = product.compareAtPrice;
          const tag = product.supportingTagLine;
          const title = product.title;
          const imgUrl = product.imgUrl;
          const imgAltText = product.imgAltText;

          const upsellItem = document.createElement("div");
          upsellItem.className = "cart-upsell__item";

          upsellItem.innerHTML = `
            <div class="cart-upsell__item__loading-overlay">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#ccc" stroke-width="4" opacity="0.25" />
                <path d="M22 12a10 10 0 0 1-10 10" stroke="#447fbf" stroke-width="4" stroke-linecap="round">
                  <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite" />
                </path>
              </svg>
            </div>
            <img src="${imgUrl}" alt="${imgAltText}" />
            <div>
              <p class="cart-upsell-item__title">${title}</p>
              <p class="cart-upsell-item__tag">${tag}</p>
              <div class="cart-upsell__item__pricing">
                <span class="cart-upsell-item__compare-at-price">${formatMoney(compareAtPrice)}</span>
                <span class="cart-upsell-item__price">${formatMoney(price)}</span>
                <button class="cart-upsell-item__add">${window.cartLocaleTranslations.upsellAdd}</button>
              </div>
            </div>            
          `;

          upsellItem.querySelector('.cart-upsell-item__add').addEventListener('click', (e) => addUpsell(e, variantId));
          document.querySelector(".cart-upsell__track")?.appendChild(upsellItem);
        });
      });

    function addUpsell(event, id) {
      const containerItem = event.currentTarget.closest('.cart-upsell__item');
      const overlay = containerItem.querySelector('.cart-upsell__item__loading-overlay');
      overlay.style.display = "flex";

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: id,
          quantity: 1,
        })
      })
        .then(async res => {
          if (!res.ok) {
            const errorData = await res.json().catch(() => ({}));
            throw new Error(errorData.message || `Request failed with status ${res.status}`);
          }
          return res.json();
        })
        .then(async data => {
          await animateAndRemove(containerItem);

          await renderCartItems();
          getCartTotal();
        })
        .catch(err => {
          console.error('Error adding upsell item:', err.message);
        });
    }

    const track = document.querySelector('.cart-upsell__track');

    let isDown = false;
    let startX;
    let scrollLeft;

    const startDrag = (x) => {
      isDown = true;
      track.classList.add('dragging');
      startX = x - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    };

    const endDrag = () => {
      isDown = false;
      track.classList.remove('dragging');
    };

    const drag = (x) => {
      if (!isDown) return;
      const walk = (x - track.offsetLeft - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    };

    // Mouse events
    track.addEventListener('mousedown', (e) => startDrag(e.pageX));
    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('mousemove', (e) => drag(e.pageX));

    // Touch events
    track.addEventListener('touchstart', (e) => startDrag(e.touches[0].pageX), { passive: true });
    track.addEventListener('touchend', endDrag);
    track.addEventListener('touchmove', (e) => drag(e.touches[0].pageX), { passive: true });
  }


  function bindActions(item) {
    const removeButton = item.querySelector(".remove-item");
    const increaseQuantity = item.querySelector(".qty-plus");
    const decreaseQuantity = item.querySelector(".qty-minus");
    let isProcessing = false;

    const guardedAction = (fn) => {
      return async (...args) => {
        if (isProcessing) return;
        isProcessing = true;
        try {
          await fn(...args);
        } finally {
          isProcessing = false;
        }
      };
    };

    removeButton.addEventListener("click", guardedAction(() => updateQuantity(item, 0)));
    increaseQuantity.addEventListener("click", guardedAction(() => updateQuantity(item, 1)));
    decreaseQuantity.addEventListener("click", guardedAction(() => updateQuantity(item, -1)));

  }

  let isUpdating = new Set();

  async function refreshCartUI() {
    await renderCartItems();
    await getCartTotal();
  }

  function updateQuantity(item, value) {
    const itemKey = item.dataset.key;

    if (isUpdating.has(itemKey)) return;
    isUpdating.add(itemKey);

    const displayedQuantity = Number(item.querySelector(".displayed-quantity").innerText);
    let newQuantity = displayedQuantity + value;

    if (value === 0) newQuantity = 0;

    const overlay = item.querySelector('.inline-cart-item__loading-overlay');
    overlay.style.display = 'flex';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: newQuantity })
    })
      .then(res => res.json())
      .then(async cart => {
        await checkPromoItems(cart);
        await refreshCartUI();
      })
      .catch(async () => {
        await refreshCartUI();
      })
      .finally(() => {
        if (overlay && overlay.isConnected) {
          overlay.style.display = "none";
        }
        isUpdating.delete(itemKey);
      });
  }

  async function matchCartKeys(cart) {
    const newCartKeys = new Set(cart.items.map(i => i.key));
    const domItems = document.querySelectorAll('.inline-cart-item');

    // Find DOM items with keys that no longer exist in the cart
    const mismatchedItems = Array.from(domItems).filter(domItem => {
      return !newCartKeys.has(domItem.dataset.key);
    });

    if (mismatchedItems.length === 1) {
      const staleDomItem = mismatchedItems[0];

      // Find the item in cart that isn't in the DOM
      const domKeys = new Set(Array.from(domItems).map(i => i.dataset.key));
      const updatedCartItem = cart.items.find(item => !domKeys.has(item.key));

      if (updatedCartItem) {
        // Patch the DOM element with the new key
        staleDomItem.dataset.key = updatedCartItem.key;
        staleDomItem.querySelectorAll('[data-key]').forEach(el => {
          el.dataset.key = updatedCartItem.key;
        });
      }
    }

    return;
  }

  async function getCartTotal() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('Failed to fetch cart data');
      const cart = await res.json();

      // The threshold arrives per-country and already in the presentment
      // currency (snippets/free-shipping-config.liquid) — same source of
      // truth as the PDP bar and the replenishment page (UK port, 1a452e4).
      const freeShippingThreshold = Number(window.cartData.freeShippingThreshold) || 0;
      const freeShippingOffered = window.cartData.freeShippingPossible === 'true' && freeShippingThreshold > 0;
      const totalPriceInCents = cart.total_price;
      const totalPriceFormatted = (totalPriceInCents / 100).toFixed(2);

      if (window.NovominsPDP && typeof window.NovominsPDP.setCartTotal === 'function') {
        window.NovominsPDP.setCartTotal(totalPriceInCents / 100);
      }

      if (cart.discount_codes.length > 0) {
        const discountContainer = document.querySelector('.display-discount');

        cart.discount_codes.forEach(code => {
          if (code.applicable === true) {
            const exists = discountContainer.querySelector(`[data-discount-code="${code.code}"]`);
            if (!exists) {
              const coupon = createCouponElement(code.code);
              coupon.dataset.discountCode = code.code;
              discountContainer.appendChild(coupon);
            }
          }
        });
      }

      document.querySelector('.cart-total__amount').textContent = formatMoney(totalPriceInCents);

      // The threshold applies to subscription orders too (since 2026-10-09 the
      // "Free Delivery For SNS" profile mirrors the General profile's $40 rule).

      // Where no free-shipping rate exists, never show the "Shipping — FREE"
      // row: without this guard a zero threshold reads as "already unlocked".
      if (!freeShippingOffered) {
        freeShipping = false;
        document.querySelector('.cart-shipping').style.display = 'none';
        if (document.querySelector('.cart-shipping-requirement')) {
          document.querySelector('.cart-shipping-requirement').style.display = 'none';
        }
        if (document.querySelector('.cart-shipping-requirement--hit')) {
          document.querySelector('.cart-shipping-requirement--hit').style.display = 'none';
        }
      } else if (totalPriceFormatted >= freeShippingThreshold) {
        freeShipping = true;
        document.querySelector('.cart-shipping').style.display = 'flex';
        if (document.querySelector('.cart-shipping-requirement')) {
          document.querySelector('.cart-shipping-requirement').style.display = 'none';
        }
        if (document.querySelector('.cart-shipping-requirement--hit')) {
          document.querySelector('.cart-shipping-requirement--hit').style.display = 'block';
        }
      } else {
        freeShipping = false;
        const remainingAmount = formatMoney((freeShippingThreshold - totalPriceInCents / 100).toFixed(2));
        const percentageComplete = ((totalPriceInCents / 100) / freeShippingThreshold * 100).toFixed(2);
        document.querySelector('.cart-shipping').style.display = 'none';
        if (document.querySelector('.cart-shipping-requirement')) {
          document.querySelector('.cart-shipping-requirement').style.display = 'block';
        }
        if (document.querySelector('.cart-shipping-requirement--hit')) {
          document.querySelector('.cart-shipping-requirement--hit').style.display = 'none';
        }
        if (document.querySelector('.remaining-amount')) {
          document.querySelector('.remaining-amount').textContent = `${remainingAmount}`;
        }
        if (document.querySelector('.cart-gifts__progress-bar__progress')) {
          document.querySelector('.cart-gifts__progress-bar__progress').style.width = `${percentageComplete}%`;
        }
      }

      updateProductPageGifting(totalPriceInCents);
      hideGiftProductControls();
      if (document.querySelector('.estimated-points-total')) {
        updatePointsEarnedDisplay(totalPriceInCents);
      }

      setTimeout(() => {
        updatePriceValues(totalPriceInCents);
      }, 300);

      return totalPriceFormatted;
    } catch (err) {
      console.error('Error fetching cart total:', err);
      return null;
    }
  }

  function updateProductPageGifting(totalPriceInCents) {
    const giftingTiers = document.querySelectorAll('.gifting-tier');

    if (giftingTiers.length === 0) return;

    giftingTiers.forEach(tier => {
      const goal = Number(tier.dataset.goal) || 0;
      if ((totalPriceInCents / 100) >= goal) {
        tier.querySelector('.gifting-tier--unlocked').style.display = 'block';
        tier.querySelector('.gifting-tier--locked').style.display = 'none';
      } else {
        tier.querySelector('.gifting-tier--unlocked').style.display = 'none';
        tier.querySelector('.gifting-tier--locked').style.display = 'block';
      }
    });
  }

  function updatePointsEarnedDisplay(totalPriceInCents) {
    const currencyRate = window.Shopify?.currency?.rate || 1;

    const points = Math.floor((totalPriceInCents / 100) / currencyRate);
    const pointsEarnedYesEl = document.querySelector('.points-earned__yes');
    const pointsEarnedNoEl = document.querySelector('.points-earned__no');
    const pointsEarnedEl = document.querySelector('.estimated-points-total');

    // Points block is not rendered on this store — skip so the caller
    // (getCartTotal) can carry on updating savings/discount amounts.
    if (!pointsEarnedYesEl || !pointsEarnedNoEl || !pointsEarnedEl) return;

    // if points are over 50, double them (influence.io rule)
    pointsEarnedEl.textContent = points > 50 ? points * 2 : points;

    const doubleThresholdEl = document.querySelector('.double-threshold');
    const doubleThreshold = doubleThresholdEl ? Number(doubleThresholdEl.dataset.threshold) : null;

    if (doubleThresholdEl) {
      doubleThresholdEl.textContent = Math.floor(doubleThreshold * currencyRate);
    }

    if (points > 0) {
      pointsEarnedYesEl.style.display = 'block';
      pointsEarnedNoEl.style.display = 'none';
    } else {
      pointsEarnedYesEl.style.display = 'none';
      pointsEarnedNoEl.style.display = 'block';
    }
  }

  function createCouponElement(code) {
    const div = document.createElement("div");
    div.className = "coupon";
    div.dataset.discountCode = code;

    div.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor">
        <path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path>
        <path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path>
      </svg>
      ${code}
      <button class="coupon-remove" aria-label="Remove discount">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
          <circle cx="6" cy="6" r="6" fill="#d00"/>
          <path d="M4 4l4 4M8 4l-4 4" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    `;

    div.querySelector('.coupon-remove').addEventListener('click', () => onRemoveDiscount(code, div));

    return div;
  }

  async function onRemoveDiscount(codeToRemove, elementToRemove) {
    try {
      // Step 1: Get current cart
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      // Step 2: Get current discounts (may be null or [])
      const currentDiscounts = cart.discount_codes?.map(d => d.code) || [];

      // Step 3: Filter out the discount to remove
      const updatedDiscounts = currentDiscounts.filter(code => code !== codeToRemove);

      // Step 4: Update cart with remaining discounts
      const updateRes = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: updatedDiscounts.join(',') })
      });

      if (updateRes.ok && elementToRemove) {
        elementToRemove.remove();
      }

      await renderCartItems();
      getCartTotal();

    } catch (error) {
      console.error('Error removing discount:', error);
    }
  }

  async function animateAndRemove(item, duration = 300) {
    return new Promise(resolve => {
      item.style.transition = 'height .3s ease';
      item.style.overflow = 'hidden';
      item.style.height = `${item.scrollHeight}px`;
      item.offsetHeight; // force reflow
      item.style.height = '0px';

      setTimeout(() => {
        item.remove();
        requestAnimationFrame(() => {
          resolve(); // ensures browser has processed DOM change
        });
      }, duration);
    })
  }

  function updatePriceValues(totalPriceInCents) {
    // Subtotal: compare-at price × quantity over the items. The base shipping
    // price is only ever a saving (when free shipping is unlocked), so it feeds
    // the total discount and the struck-through total, never the subtotal.
    let subTotalPrice = 0;
    const cartItems = document.querySelectorAll(".inline-cart-item");

    cartItems.forEach(item => {
      const compareAtPricePerItem = Number(item.dataset.compareAtPrice) || 0;
      const quantity = Number(item.querySelector(".displayed-quantity").innerText);
      if (compareAtPricePerItem <= 0) {
        subTotalPrice += (Number(item.dataset.pricePerProduct) / 100) * quantity;
      } else {
        subTotalPrice += compareAtPricePerItem * quantity;
      }
    });

    const preShippingDiscount = (subTotalPrice - (totalPriceInCents / 100)) * 100;
    let totalDiscountInCents;

    const itemsSubtotalInCents = subTotalPrice * 100;
    // Free shipping unlocked: the base shipping price is a saving, so it joins
    // the total discount and the struck-through total (subTotalPrice from here
    // on) — but not the subtotal row above.
    if (freeShipping === true) {
      subTotalPrice += shipping;
      totalDiscountInCents = preShippingDiscount + (shipping * 100);
    } else {
      totalDiscountInCents = preShippingDiscount;
    }

    subTotalPrice = subTotalPrice * 100;


    document.querySelector('.cart-subtotal__amount').innerText = formatMoney(itemsSubtotalInCents);

    document.querySelector('.cart-total__amount').innerText = `${formatMoney(totalPriceInCents)}`;

    if (preShippingDiscount > 0) {
      document.querySelector('.cart-discounts__amount').innerText = `-${formatMoney(preShippingDiscount)}`;
      document.querySelector('.cart-discounts').style.display = "flex";
    } else {
      document.querySelector('.cart-discounts').style.display = "none";
    }

    if (totalDiscountInCents > 0) {
      document.querySelector('.cart-savings__amount').innerText = `-${formatMoney(totalDiscountInCents)}`;
      document.querySelector('.cart-savings').style.display = "flex";
    } else {
      document.querySelector('.cart-savings').style.display = "none";
    }

    if (subTotalPrice > totalPriceInCents) {
      document.querySelector('.cart-total__strike').innerText = formatMoney(subTotalPrice);
      document.querySelector('.cart-total__strike').style.display = "block";
    } else {
      document.querySelector('.cart-total__strike').style.display = "none";
    }
  }

  function updateHeaderIconNumber(count) {
    // Update cart count bubble in header
    const existingBubbleText = document.querySelector('.cart-count-bubble span');
    if (existingBubbleText) {
      existingBubbleText.textContent = count;
      return;
    }

    const cartIconContainer = document.querySelector('.header__icon--cart') || document.querySelector('#cart-icon-bubble');
    if (!cartIconContainer) return;

    const div = document.createElement('div');
    div.className = 'cart-count-bubble';

    div.innerHTML = `
      <span aria-hidden="true">${count}</span>
    `;

    cartIconContainer.appendChild(div);
  }

  async function checkPromoItems(cart) {
    const normalizedCart = await enforcePromoCapState(cart);
    const activeCart = normalizedCart || cart;
    const promoProductIds = new Set([
      "15399219855740",
      "15399386317180",
      "15399391756668",
      "15399397753212"
    ]);

    // Filter out items that are not promo products
    const nonPromoItems = activeCart.items.filter(item => {
      return !promoProductIds.has(item.product_id.toString());
    });

    // If there's at least one non-promo item, do nothing
    if (nonPromoItems.length > 0) return activeCart;

    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });

    await renderCartItems();
    getCartTotal();

    return fetchCartData();
  }

  async function renderCartItems() {
    try {
      let cart = await fetchCartData();
      cart = await enforcePromoCapState(cart);

      if (!cart.items?.length) {
        const remainingItems = document.querySelectorAll('.inline-cart-item');

        remainingItems.forEach(async item => {
          animateAndRemove(item);
        });

        if (document.querySelector(".cart-upsell")) {
          document.querySelector(".cart-upsell").style.display = "none";
        }
        updateHeaderIconNumber(cart.item_count);
        return;
      }

      if (document.querySelector(".cart-upsell")) {
        document.querySelector(".cart-upsell").style.display = "block";
      }

      const productIds = cart.items.map(item => item.product_id);
      let enrichedProducts = [];

      try {
        enrichedProducts = await fetchProducts(productIds);
      } catch (enrichmentError) {
        console.warn('Error enriching cart products, using cart payload fallback:', enrichmentError);
      }

      updateHeaderIconNumber(cart.item_count);

      const productMap = new Map();
      enrichedProducts.forEach(product => {
        productMap.set(product.id.toString(), product);
      });

      const cartList = document.querySelector('.inline-cart-items');
      cartList.innerHTML = '';

      cart.items.forEach(item => {
        const productData = productMap.get(item.product_id.toString()) || {};
        const itemImage = item.featured_image?.url || item.image || productData.imgUrl || '';
        const itemImageAlt = item.featured_image?.alt || item.product_title || productData.imgAltText || '';
        const compareAtPrice = Number(productData.compareAtPrice) || 0;
        const linePrice = typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
        const pricePerProduct = typeof item.final_price === 'number'
          ? item.final_price
          : (item.quantity > 0 ? linePrice / item.quantity : 0);
        const isPromoFreeGift = String(item.product_id) === '15993557680508'
          && Number(linePrice) === 0
          && Boolean(window.cartLocaleTranslations.freeGiftText);
        const itemPriceText = isPromoFreeGift
          ? window.cartLocaleTranslations.freeGiftText
          : formatMoney(linePrice);
        const saving = compareAtPrice
          ? (((compareAtPrice - (pricePerProduct / 100)) / compareAtPrice) * 100).toFixed(0)
          : null;
          const li = document.createElement('li');
          li.className = 'inline-cart-item';
          li.dataset.subscriptionProduct = item.selling_plan_allocation ? 'true' : 'false';
          li.dataset.productId = item.product_id;
          li.dataset.key = item.key;
          li.dataset.compareAtPrice = compareAtPrice || '';
          li.dataset.pricePerProduct = pricePerProduct;
          li.dataset.variantId = productData.variantId || item.variant_id;

          const blackFridayProductIds = [
            15692776407420, // Hair Health Bundle
            15692773753212, // Sleep & Recovery Bundle
            15692770705788, // Complete Man Bundle
            15692761465212, // Energy & Focus for Work Bundle
            15692758221180, // Gym Performance Bundle
            15692740690300, // Complete Women Bundle
            15692740133244, // Energy & Mood Bundle
            15692737905020, // Intimate Health Essentials
            15692737380732, // The Glow-Up Bundle
            15692736168316, // Menopause Support Stack
            15692734923132, // Hormone Harmony Bundle
            15692731842940, // Focus & Concentration Bundle
            15692730663292, // Growth & Development Bundle
            15692726206844, // The Ultimate Kids Immunity Stack
            15692720275836, // The Bedtime Basics
            15692715524476  // The Complete Sleep Solution
          ];

          let iBlackFridayProduct = blackFridayProductIds.indexOf(item.product_id);

          // AU (Appstle) selling plans expose a single option; UK plans have two.
          // Guard the index — a missing option must not crash the whole cart render.
          let deliverySchedule = item.selling_plan_allocation?.selling_plan?.options?.[1]?.value;

          const showCompareAt = (compareAtPrice * 100) > pricePerProduct;

          li.innerHTML = `
              <div class="inline-cart-item__loading-overlay">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#ccc" stroke-width="4" opacity="0.25" />
                  <path d="M22 12a10 10 0 0 1-10 10" stroke="#447fbf" stroke-width="4" stroke-linecap="round">
                    <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite" />
                  </path>
                </svg>
              </div>
              <img src="${itemImage}" alt="${itemImageAlt}">
      
              <div class="cart-item__info">
                <div class="ruk_rating_snippet" data-sku="${item.handle};${item.sku};${item.variant_id}"></div>
                <p class="cart-item__title">${item.product_title}</p>
                <p class="cart-item__tag">${productData.supportingTagLine || ''}</p>
      
                <div class="cart-item__sub-details" style="${item.selling_plan_allocation ? 'display: block' : ''}">
                  <p class="cart-item__delivery">
                    ${(
              {
                '2-month': window.cartLocaleTranslations.delivery2,
                '3-month': window.cartLocaleTranslations.delivery3,
              }[deliverySchedule] ?? window.cartLocaleTranslations.delivery)
            }
                  </p>
                  ${saving ? `
                    <p class="cart-item__savings">${window.cartLocaleTranslations.itemSaving} <span class="cart-item__savings--percentage">${saving}%</span></p>
                  ` : ''}
                </div>

                ${iBlackFridayProduct !== -1 ? `
                  <div class="cart-item__sub-details" style="display: block;">
                    <p class="cart-item__savings">${window.cartLocaleTranslations.itemSaving} <span class="cart-item__savings--percentage">${saving}%</span></p>
                  </div>
                ` : ''}
              </div>
      
              <div class="cart-item__actions">
                <button class="remove-item" data-key="${item.key}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                    <path d="M1.5 4H3M3 4H15M3 4V14.5C3 14.8978 3.15804 15.2794 3.43934 15.5607C3.72064 15.842 4.10218 16 4.5 16H12C12.3978 16 12.7794 15.842 13.0607 15.5607C13.342 15.2794 13.5 14.8978 13.5 14.5V4H3ZM5.25 4V2.5C5.25 2.10218 5.40804 1.72064 5.68934 1.43934C5.97064 1.15804 6.35218 1 6.75 1H9.75C10.1478 1 10.5294 1.15804 10.8107 1.43934C11.092 1.72064 11.25 2.10218 11.25 2.5V4M6.75 7.75V12.25M9.75 7.75V12.25" stroke="#1D2025" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                
                <p class="cart-item__compare-at-price" style="display: ${showCompareAt ? "block" : "none"}">
                 ${formatMoney(compareAtPrice * item.quantity * 100)}
                </p>
                <p class="cart-item__price">${itemPriceText}</p>
      
                <div class="cart-item__qty">
                  <button class="qty-minus" data-key="${item.key}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="2" viewBox="0 0 9 2" fill="none">
                      <path d="M8.10156 1L0.601562 1" stroke="#1D2025"/>
                    </svg>
                  </button>
                  <span class="displayed-quantity">${item.quantity}</span>
                  <button class="qty-plus" data-key="${item.key}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <path d="M3.85156 0.25V7.75" stroke="#1D2025"/>
                      <path d="M7.60156 4L0.101562 4" stroke="#1D2025"/>
                    </svg>
                  </button>
                </div>
              </div>

              <span class="cart-divider"></span>
            `;

          cartList.appendChild(li);
          bindActions(li);
          matchCartKeys(cart);
          // window.loadReviewsIoRatingSnippets();
        });
    } catch (err) {
      console.error('Error rendering cart:', err);
    }
  }

  function hideGiftProductControls() {
    // loop over cart items and hide qty controls and the remove button
    // for product with the data-product-id 15646588469628
    const giftProductId = "15646588469628";
    const cartItems = document.querySelectorAll('.inline-cart-item');

    cartItems.forEach(item => {
      if (item.dataset.productId === giftProductId) {
        const removeButton = item.querySelector('.remove-item');
        const qtyControls = item.querySelector('.cart-item__qty');

        if (removeButton) removeButton.style.display = 'none';
        if (qtyControls) qtyControls.style.display = 'none';
      }
    });
  }

  // bindCartEvents();
  getCartTotal();
  // upsellProducts();

  function setViewportHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  // Initial set
  setViewportHeight();

  // Update on resize or orientation change
  window.addEventListener('resize', setViewportHeight);
  window.addEventListener('orientationchange', setViewportHeight);

  async function fetchCartData() {
    const response = await fetch('/cart.js');

    if (!response.ok) {
      throw new Error('Failed to load cart');
    }

    return response.json();
  }

  async function addItemsToCart(items) {
    const requestItems = (items || [])
      .filter((item) => item && item.id)
      .map((item) => ({
        id: item.id,
        quantity: item.quantity || 1,
      }));

    if (!requestItems.length) {
      throw new Error('Add to cart failed: missing line items');
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: requestItems })
    });

    if (!response.ok) {
      let errorMessage = 'Add to cart failed';

      try {
        const errorData = await response.json();
        if (errorData && errorData.description) {
          errorMessage = errorData.description;
        }
      } catch (error) {
        errorMessage = 'Add to cart failed';
      }

      throw new Error(errorMessage);
    }

    return response.json();
  }

  async function enforcePromoCapState(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return cart;
    }

    const bundlePresent = cart.items.some((item) => String(item.product_id) === promoBundleProductId);

    if (!bundlePresent) {
      return cart;
    }

    const capItems = cart.items.filter((item) => promoCapVariantIds.includes(String(item.variant_id)));
    const totalCapQuantity = capItems.reduce((total, item) => total + Number(item.quantity || 0), 0);

    if (totalCapQuantity > 0) {
      return cart;
    }

    try {
      await addItemsToCart([
        {
          id: defaultPromoCapVariantId,
          quantity: 1,
        }
      ]);
      return fetchCartData();
    } catch (error) {
      console.error('Error adding missing promo cap:', error);
      return cart;
    }
  }
};

export default inlineCart;